import { refreshPage, setCookie } from './helper';

export const getString = (key = "",translationsObj = {}, selectedLang = false) => {
    const lang = selectedLang ? selectedLang : window.lang;
    try {
        if (translationsObj[lang][key] !== undefined)
            return translationsObj[lang][key];
    } catch (error) {
        console.error(`translation failed for the word: ${key} in ${lang} lang`)
    }

    return "";
}

export const setLang = (ln="") =>{
    if(window.lang == ln)
      return;
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = "lang" + "=" + ln + expires + "; path=/";
    refreshPage();
  }